import { takeLatest, put, call } from 'redux-saga/effects';
import { history } from '@commons';
import { updateFunrural } from '../service';
import {
  CREATE_FUNRURAL,
  CREATE_FUNRURAL_PENDING,
  CREATE_FUNRURAL_SUCCESS,
  CREATE_FUNRURAL_FAILURE,
} from '@handler';
import { AlertSuccess, AlertError } from '@components/common/AlertToast';

function* sagaCreateFunrural(action) {
  yield put({ type: CREATE_FUNRURAL_PENDING });

  try {
    yield call(updateFunrural,
      {
        ...action.data,
        id: action.data.id
      }
    );

    yield put({ type: CREATE_FUNRURAL_SUCCESS, registro: action.data });
    history.push('/fiscal/funrural');
    AlertSuccess('Funrural atualizado com sucesso!');
  } catch (error) {
    yield put({ type: CREATE_FUNRURAL_FAILURE, registro: action.data });
    AlertError('Falha ao atualizar Funrural! Tente novamente...');
  }
}

export default function* watchCreateFunrural() {
  yield takeLatest(CREATE_FUNRURAL, sagaCreateFunrural);
}
